import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';
import Tabs from '../../components/Tabs';
import DataTabs from './DataTabs';
import Plans from 'cccisd-tabs';
import { DataBrowser } from 'cccisd-laravel-assignment';

const appdefs = window.cccisd.appDefs.app;
export default class ViewData extends React.Component {
    // state = {
    //     isLoading: true,
    // };

    static propTypes = {
        projectId: PropTypes.number,
        labelForProject: PropTypes.string,
        labelForQuest: PropTypes.string,
        labelForDeployment: PropTypes.string,
        appname: PropTypes.string,
    };

    static defaultProps = {
        appname: 'wrapstat',
    };

    getDataTabs = () => {
        const dataTabs = [
            {
                name: 'wfiCareCoord',
                title: 'WFI-EZ Care Coordinator',
                license: 'wfi',
                content: (
                    <DataTabs
                        key="wfiCC"
                        projectId={appdefs.wfiProjectId}
                        assignmentId={appdefs.wfiCareCoordAssignmentId}
                        // deploymentWhitelist={this.state.wfiCCDeploymentWhitelist}
                    />
                ),
            },
            {
                name: 'wfiCaregiver',
                title: 'WFI-EZ Caregiver',
                license: 'wfi',
                content: (
                    <DataTabs
                        key="wfiCG"
                        projectId={appdefs.wfiProjectId}
                        assignmentId={appdefs.wfiCaregiverAssignmentId}
                        // deploymentWhitelist={this.state.wfiCGDeploymentWhitelist}
                    />
                ),
            },
            {
                name: 'wfiTeamMember',
                title: 'WFI-EZ Team Member',
                license: 'wfi',
                content: (
                    <DataTabs
                        key="wfiTM"
                        projectId={appdefs.wfiProjectId}
                        assignmentId={appdefs.wfiTeamMemberAssignmentId}
                        // deploymentWhitelist={this.state.wfiTMDeploymentWhitelist}
                    />
                ),
            },
            {
                name: 'wfiYouth',
                title: 'WFI-EZ Youth',
                license: 'wfi',
                content: (
                    <DataTabs
                        key="wfiY"
                        projectId={appdefs.wfiProjectId}
                        assignmentId={appdefs.wfiYouthAssignmentId}
                        // deploymentWhitelist={this.state.wfiYTDeploymentWhitelist}
                    />
                ),
            },
            {
                name: 'tom',
                title: 'TOM 2.0',
                license: 'tom',
                content: (
                    <DataTabs
                        key="tom"
                        projectId={appdefs.tomProjectId}
                        assignmentId={appdefs.tomAssignmentId}
                        // deploymentWhitelist={this.state.tomDeploymentWhitelist}
                    />
                ),
            },
            {
                name: 'dart',
                title: 'DART',
                license: 'dart',
                content: (
                    <DataTabs
                        key="dart"
                        projectId={appdefs.dartProjectId}
                        assignmentId={appdefs.dartAssignmentId}
                        // deploymentWhitelist={this.state.dartDeploymentWhitelist}
                    />
                ),
            },
        ];

        return dataTabs;
    };

    getPlans = () => {
        // get plans from appdefs to determine which tabs to show
        // if no plans are defined, show a single tab with no data message
        const plans = appdefs.plans || [];
        const dataTabs = [];
        if (plans.length === 0) {
            dataTabs.push({
                name: 'noData',
                title: 'No Data',
                content: <div>No SmartWrap plans are defined.</div>,
            });
            return dataTabs;
        }

        plans.forEach(plan => {
            dataTabs.push({
                name: plan.label,
                title: plan.label,
                content: (
                    <DataBrowser
                        key={plan.projectId + '_' + plan.name}
                        projectId={plan.projectId}
                        showAssignmentIds={[plan.youthAssignmentId, plan.caregiverAssignmentId]}
                    />
                ),
            });
        });
        return dataTabs;
    };

    render() {
        // if (this.state.isLoading) {
        //     return <Loader loading />;
        // }
        const { appname } = this.props;

        if (appname === 'smartwrap') {
            return (
                <>
                    <h2>SmartWrap View Data</h2>
                    <div className={style.pageMargin}>
                        <br />
                        <Plans tabId="smartwrapViewData" tabList={this.getPlans()} />
                    </div>
                </>
            );
        }

        return (
            <>
                <h2>Wrapstat View Data</h2>
                <div className={style.pageMargin}>
                    <br />
                    <Tabs tabId="wrapstatViewData" tabList={this.getDataTabs()} />
                </div>
            </>
        );
    }
}
